module.exports = __webpack_public_path__ + "img/home-workspaces.d09e9094.png";